import { AES, enc } from 'crypto-js';

const getEncryptionKey = () => {
  const browserFingerprint = window.navigator.userAgent + 
                           window.navigator.language + 
                           (window.screen.width * window.screen.height) +
                           document.domain; // Add domain for slight improvement
  
  const secretKey = process.env.REACT_APP_ENCRYPTION_SECRET || 'dev-secret-key-2024';
  return btoa(`${browserFingerprint}-${secretKey}`).substring(0, 32);
};

export const encryptData = (data) => {
  try {
    const key = getEncryptionKey();
    return AES.encrypt(JSON.stringify(data), key).toString();
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

export const decryptData = (ciphertext) => {
  if (!ciphertext) return null;
  
  try {
    const key = getEncryptionKey();
    const bytes = AES.decrypt(ciphertext, key);
    return JSON.parse(bytes.toString(enc.Utf8));
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

// Secure localStorage wrapper
export const secureStorage = {
  setItem: (key, value, encrypt = true, expirationMinutes = 60) => {
    const expirationTime = Date.now() + (expirationMinutes * 60 * 1000);
    const dataWithExpiration = { data: value, expires: expirationTime };
    const encrypted = encrypt ? encryptData(dataWithExpiration) : JSON.stringify(dataWithExpiration);
    localStorage.setItem(key, encrypted);
  },
  
  getItem: (key, encrypted = true) => {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    
    try {
      const decrypted = encrypted ? decryptData(stored) : JSON.parse(stored);
      if (decrypted?.expires && Date.now() > decrypted.expires) {
        localStorage.removeItem(key);
        return null;
      }
      return decrypted?.data;
    } catch (e) {
      localStorage.removeItem(key); // Clear corrupted data
      return null;
    }
  }
};
